import React from 'react';
import { Div } from 'Common/components/Atoms/Div';
import { Col } from 'Common/components/Atoms/Flex';
import { Text } from 'Common/components/Atoms/Text';
import { ExpandableCard } from 'Common/components/Molecules/ExpandableCard';
import { FAQ } from 'DisplayText/ReviewerOnboarding/Landing/FAQs';
import { styled, useTheme } from '@mui/material';

const Title = styled(Text)(({ theme }) => ({
  '&&&&': {
    fontSize: 36,
    marginBottom: 16,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
      marginBottom: 32,
    },
  },
}));

export const FAQs: React.FC = () => {
  const theme = useTheme();
  const faqs: Props[] = [
    {
      header: FAQ.EXPECTED_COMMITMENT_HEADER,
      body: [FAQ.EXPECTED_COMMITMENT_BODY],
    },
    {
      header: FAQ.EXPECTED_EXPERIENCE_HEADER,
      body: [FAQ.EXPECTED_EXPERIENCE_BODY],
    },
    {
      header: FAQ.EXPECTED_COMP_HEADER,
      body: [FAQ.EXPECTED_COMP_BODY],
    },
    {
      header: FAQ.PAYMENT_LOGISTICS_HEADER,
      body: [FAQ.PAYMENT_LOGISTICS_BODY],
    },
    {
      header: FAQ.REVIEW_LOGISTICS_HEADER,
      body: [FAQ.REVIEW_LOGISTICS_BODY],
    },
    {
      header: FAQ.ONBOARDING_HEADER,
      body: [FAQ.ONBOARDING_BODY],
    },
    {
      header: FAQ.APPLICATION_HEADER,
      body: [FAQ.APPLICATION_BODY],
    },
  ];
  return (
    <Col
      alignItems="center"
      justifyContent="center"
      backgroundColor={theme.palette.background.default}
      flexWrap="wrap"
      p={6}
    >
      <Title>{FAQ.TITLE}</Title>
      {faqs.map((faq: Props) => {
        return <FAQCard key={faq.header} {...faq} />;
      })}
    </Col>
  );
};

interface Props {
  header: string;
  body: string[];
}

const HeaderText = styled(Text)(({ theme }) => ({
  '&&&&': {
    width: '90%',
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
    },
  },
}));

const BodyText = styled(Text)(({ theme }) => ({
  '&&&&': {
    marginTop: 8,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
}));

export const FAQCard: React.FC<Props> = (props: Props): JSX.Element => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  return (
    <ExpandableCard
      mb={2}
      p={2}
      width="80%"
      header={<HeaderText variant="h3">{props.header}</HeaderText>}
      isExpanded={isExpanded}
      onCardClick={() => setIsExpanded(!isExpanded)}
    >
      <Div mt={2}>
        {props.body.map((p: string, index: number) => {
          return <BodyText key={index}>{p}</BodyText>;
        })}
      </Div>
    </ExpandableCard>
  );
};
